import { render, staticRenderFns } from "./booking-event-select-info.vue?vue&type=template&id=084cd448&scoped=true&"
import script from "./booking-event-select-info.ts?vue&type=script&lang=ts&"
export * from "./booking-event-select-info.ts?vue&type=script&lang=ts&"
import style0 from "./booking-event-select-info.scss?vue&type=style&index=0&id=084cd448&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084cd448",
  null
  
)

export default component.exports